import { createSelector } from '@reduxjs/toolkit';
import { getAvatar, getFirstName, getIsBot, getIsOnline, getIsResponderAI } from 'conversations-internal-schema/responders/operators/responderGetters';
// @ts-expect-error untyped file
import { getPreviewText } from 'conversations-internal-schema/thread-preview/operators/threadPreviewGetters';
// @ts-expect-error untyped file
import { getSelectedThread } from '../../../selected-thread/selectors/getSelectedThread';
import { getAssignedResponderInWidget } from '../../../responders/selectors/getAssignedResponderInWidget';
import I18n from 'I18n';
export const getNewMessagePreviewPopupData = createSelector([getSelectedThread, getAssignedResponderInWidget], (selectedThread, responder) => {
  if (!selectedThread) return;
  const previewText = getPreviewText(selectedThread);
  if (!previewText) return;
  const agentAvatarUrl = responder && getAvatar(responder) || undefined;
  const isBot = Boolean(responder && getIsBot(responder));
  const isResponderAI = Boolean(responder && getIsResponderAI(responder));
  const isOnline = Boolean(responder && getIsOnline(responder));
  const agentName = responder && getFirstName(responder) || I18n.text('conversations-visitor-ui.default.agent');
  return {
    agentName,
    agentAvatarUrl,
    isBot,
    isResponderAI,
    isOnline,
    messagePreviewText: previewText
  };
});